import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import Footer from "./Footer";
import AuthService from "../services/AuthService";
import ChatDomain from "./chatbot/ChatDomain";
// import DoubleClickDialog from "../api/common/components/clickDialogue";
import { Box, Button, CssBaseline } from "@mui/material";
import NavBar2 from "../api/common/components/NavBar";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fab from '@mui/material/Fab';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dashboard from "../../features/home/Dashboard";

const authService = new AuthService();
interface UserData {
  // name?: string;  // The question mark means this property might be undefined
  email?: string;
}
function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [userData, setUserData] = useState<UserData | null>(null);
  const [showScroll, setShowScroll] = useState(false);
  const [themeMode, setThemeMode] = useState<'light' | 'dark'>('light');
  const [fontSizeMultiplier, setFontSizeMultiplier] = useState(1); // 1 = 100% (normal)

  // Debug: Log font size changes and apply to document
  useEffect(() => {
    console.log('Font size multiplier changed to:', fontSizeMultiplier);
    // Apply font size to root element for global effect
    document.documentElement.style.fontSize = `${16 * fontSizeMultiplier}px`;
  }, [fontSizeMultiplier]);

  useEffect(() => {

    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };

    window.addEventListener('scroll', checkScrollTop);

    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, [location, navigate, showScroll]); // Ensure useEffect is correctly triggered

  const scrollTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  useEffect(() => {

    
    if (location.pathname === "/signin-oidc") {
      authService.userManager
        .signinRedirectCallback()
        .then((user) => {
          setIsAuthenticated(true);
          setIsLoading(false);
          navigate("/"); // Redirect to home page after successful authentication
        })
        .catch((error) => {
          console.error("Error during signin callback:", error);
          setError("Error during sign-in, please try again.");
          authService.login();

          setIsLoading(false);
        });
    } else {
      authService.getUser().then((user) => {
        if (user) {
          setIsAuthenticated(true);
          setIsLoading(false);
          // Fetching user data like name, email
          authService
            .getUserData()
            .then((data) => {
              setUserData(data);
            })
            .catch((err) => {
              console.error("Error fetching user data:", err);
            });
        } else if (
          location.pathname !== "/signin-oidc" &&
          location.pathname !== "/login"
        ) {
          setIsAuthenticated(false);
          authService.login();
        } else {
          setIsLoading(false);
        }
      });
    }
  }, [location, navigate]);

  
  const logout = () => {
    authService.logout();
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;


  }
  
  const toggleTheme = () => {
    setThemeMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const increaseFontSize = () => {
    setFontSizeMultiplier((prev) => {
      const next = Math.min(prev + 0.1, 1.5);
      console.log('Increase font size: from', prev, 'to', next);
      return next;
    });
  };

  const decreaseFontSize = () => {
    setFontSizeMultiplier((prev) => {
      const next = Math.max(prev - 0.1, 0.8);
      console.log('Decrease font size: from', prev, 'to', next);
      return next;
    });
  };

  const resetFontSize = () => {
    console.log('Reset font size to 1.0 (100%)');
    setFontSizeMultiplier(1);
  };

  const cycleFontSize = () => {
    setFontSizeMultiplier((prev) => {
      // Cycle through preset values: 0.8 → 1.0 → 1.2 → 1.5 → 0.8
      let next;
      if (prev < 0.9) next = 1.0;
      else if (prev < 1.1) next = 1.2;
      else if (prev < 1.4) next = 1.5;
      else next = 0.8;
      
      console.log('Cycle font size: from', prev, 'to', next);
      return next;
    });
  };

  const theme = createTheme({
    // Remove the 'TextareaAutosize' property from the object literal
   
    typography: {
      fontSize: 14 * fontSizeMultiplier,
      htmlFontSize: 16 * fontSizeMultiplier,
    },
    palette: {
      mode: themeMode,
      
      // primary: {
      //   light: '#e0f7fa',
      //   main: '#b2ebf2',
      //   dark: '#80deea',
      //   contrastText: '#fff',
      // },
      // secondary: {
      //   light: '#cfd8dc',
      //   main: '#b0bec5',
      //   dark: '#90a4ae',
      //   contrastText: '#000',
      // },
  
    },
  });

  
  

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <NavBar2
          isAuthenticated={isAuthenticated}
          email={userData?.email}
          toggleTheme={toggleTheme}
          logout={logout}
          increaseFontSize={increaseFontSize}
          decreaseFontSize={decreaseFontSize}
          resetFontSize={resetFontSize}
          cycleFontSize={cycleFontSize}
          fontSizeMultiplier={fontSizeMultiplier}
        />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <Box
          component="main"
          px={{ xs: 2, sm: 4, md: 10, lg: 20 }}
          sx={{
            marginBottom: "auto",
            overflowX: "auto",
            maxWidth: "100vw",
          }}
        >
          {/* {isAuthenticated && userData && <> <button onClick={logout}>Logout</button>
                  <p>Your email: {userData.email || "No email available"}</p>
                  </>} */}

          {location.pathname === "/" ? <Dashboard /> : <Outlet />}
          {/* <DoubleClickDialog /> */}
          {/* </MDBContainer> */}
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <Footer />
        </Box>

        {showScroll && (
          <Fab
            color="secondary"
            size="small"
            onClick={scrollTop}
            style={{ position: "fixed", bottom: "150px", right: "20px" }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        )}
        {/* </div> */}
      </ThemeProvider>
    </>
  );
}

export default App;
